<template>
    <v-app-bar fixed app>
        <v-app-bar-nav-icon
          data-testid="toolbar-toggle-drawer-btn"
          class="toolbar-toggle-drawer-btn"
          @click.stop="toggleDrawer"
        />
        <v-toolbar-title>Store Space Administration</v-toolbar-title>
        <v-spacer />
        <v-menu>
            <template v-slot:activator="{ on }">
                <v-toolbar-title v-on="on" id="toolbar-title">
                    <span v-if="currentUser">{{ currentUser.first_name }} {{ currentUser.last_name }}</span>
                    <v-icon>arrow_drop_down</v-icon>
                </v-toolbar-title>
            </template>

            <v-list>
                <v-list-item>
                    <v-switch
                      data-testid="toolbar-toggle-theme-switch"
                      class="toolbar-toggle-theme-switch"
                      :label="`Dark Theme`"
                      v-model="$vuetify.theme.dark"
                      inset
                    />
                </v-list-item>
                <v-list-item
                  data-testid="toolbar-logout-btn"
                  class="toolbar-logout-btn"
                  @click="logout"
                >
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      currentUser: state => state.user.profile,
      drawerExpanded: state => state.app.applicationSettings.drawerExpanded,
      facilitiesList: state => state.facility.facilitiesList
    }),

    darkTheme: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(newValue) {
        this.$store.dispatch("setDarkTheme", newValue);
      }
    }
  },

  methods: {
    toggleDrawer() {
      this.$store.dispatch("toggleDrawer", !this.drawerExpanded);
    },
    logout() {
      this.$store.dispatch("logout");
    }
  },

  created() {
    if (this.facilitiesList && !this.facilitiesList.length) {
      this.$store.dispatch("getFacilityList");
    }
  }
};
</script>

<style scoped>
    #toolbar-title:hover {
        cursor: pointer;
    }
</style>
